$(function() {
$('.swiper-container').each(function (index, element) {
        const $element = $(element); 

        const next = $element.find('.swiper-button-next').get(0); 
        const prev = $element.find('.swiper-button-prev').get(0); 


        new Swiper($element.find('.swiper').get(0), { 
            loop: false,
            noSwiping: true,
            noSwipingClass: '.color',
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                993: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                }
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });
        
    });

    const $swiperEl = $('.hero-swiper .swiper-product');
    const $swiperWrap = $('.image-prod');
    const $pagination = $swiperWrap.find('.pagination');
    const initialSlideAttr = parseInt($swiperEl.attr('data-initial-slide'), 10);
    const initialSlideIndex = !isNaN(initialSlideAttr) ? initialSlideAttr : 0;
    const swiperHeroProduct = new Swiper($swiperEl.get(0), {
            slidesPerView: 'auto',
            loop: true,
            initialSlide: initialSlideIndex,
            pagination: {
                el: $pagination.get(0),
                clickable: true,
            },
            breakpoints: {
                0: { slidesPerView: 1, spaceBetween: 0 },
                450: { slidesPerView: 1, spaceBetween: 0 },
                600: { slidesPerView: 1, spaceBetween: 0 },
                767: { slidesPerView: 1, spaceBetween: 0 },
                850: { slidesPerView: 1, spaceBetween: 0 },
                993: { slidesPerView: 1, spaceBetween: 0 },
                1600: { slidesPerView: 1, spaceBetween: 0 }
            },
            on: {
                slideChangeTransitionStart: function() {
                    const swiperInstance = this;
                    const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
                    const variantId = $activeSlide.attr('data-variant');
                    const slidePalette = $activeSlide.attr('data-palette');

                    // Update .colors palette dots immediately at start of slide transition
                    if (typeof window.updatePaletteColors === 'function') {
                        window.updatePaletteColors(variantId || 'default', slidePalette);
                    }
                },
                slideChange: function() {
                    const swiperInstance = this;
                    const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
                    const variantId = $activeSlide.attr('data-variant');
                    const slidePalette = $activeSlide.attr('data-palette');

                    // Ensure palette is updated
                    if (typeof window.updatePaletteColors === 'function') {
                        window.updatePaletteColors(variantId || 'default', slidePalette);
                    }

                    // Sync variant options in variant picker if available
                    if (variantId && !swiperInstance.isVariantSliding) {
                        const colorsEl = document.querySelector('.colors[data-variant-options]');
                        if (colorsEl && colorsEl.dataset.variantOptions) {
                            try {
                                const variantOptionsMap = JSON.parse(colorsEl.dataset.variantOptions);
                                const options = variantOptionsMap[variantId];
                                if (options && options.length) {
                                    options.forEach(function(optVal) {
                                        const input = document.querySelector('variant-selects input[value="' + optVal + '"]');
                                        if (input && !input.checked) {
                                            swiperInstance.isUserSliding = true;
                                            input.click();
                                            setTimeout(function() { swiperInstance.isUserSliding = false; }, 400);
                                        }
                                    });
                                }
                            } catch(e) {}
                        }
                    }

                    if (variantId) {
                        const $context = $swiperEl.closest('product-info');
                        
                        let $swatch = $context.find('.swatches .color[data-variant-id="' + variantId + '"]');
                        if (!$swatch.length) {
                            $swatch = $context.find('.swatches .color[data-variant="' + variantId + '"]');
                        }
                        if ($swatch.length) {
                            $swatch.addClass('active').siblings('.color').removeClass('active');
                        }

                        let $sizeBtns = $context.find('.sizes-container[data-variant="' + variantId + '"]');
                        if ($sizeBtns.length) {
                            $sizeBtns.addClass('active').siblings('.sizes-container').removeClass('active');
                            $sizeBtns.find('.btn-rose:not(.disabled)').first().addClass('active').siblings().removeClass('active');

                            if ($sizeBtns.find('.btn-rose:not(.disabled)').length === 0) {
                                $context.find('.add-to-cart').addClass('disabled');
                            } else {
                                $context.find('.add-to-cart').removeClass('disabled');
                            }
                        }

                        const variantFirstSizeBtn = $context.find('.sizes-container.active .btn-rose.active');
                        let variantIdToShow =  variantFirstSizeBtn.data('variant-id') ;
                        if (variantIdToShow){
                            $context.find('.product-price[data-variant="' + variantIdToShow + '"]').each(function() {
                                $(this).addClass('active');
                                $(this).siblings().removeClass('active');   
                            });
                        }
                    }
                }
            }
        });
    window.swiperHeroProduct = swiperHeroProduct;

    // Sync to selected variant on page load (e.g. from ?variant=... URL param)
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const initialVariantId = urlVariantId || $swiperEl.closest('product-info').attr('data-selected-variant-id') || $('.colors[data-active-variant]').attr('data-active-variant');
    if (initialVariantId) {
        if (typeof window.updatePaletteColors === 'function') {
            window.updatePaletteColors(initialVariantId, null, true);
        }
        const $slides = swiperHeroProduct.slides;
        for (let i = 0; i < $slides.length; i++) {
            const s = $slides[i];
            if (s.getAttribute('data-variant') == initialVariantId && !s.classList.contains('swiper-slide-duplicate')) {
                const loopIndex = s.getAttribute('data-swiper-slide-index');
                swiperHeroProduct.isVariantSliding = true;
                if (loopIndex !== null) {
                    swiperHeroProduct.slideToLoop(parseInt(loopIndex, 10), 0);
                } else {
                    swiperHeroProduct.slideTo(i, 0);
                }
                setTimeout(function() {
                    swiperHeroProduct.isVariantSliding = false;
                }, 300);
                break;
            }
        }
    }

    // Add to cart steps toggle
    $('.add-to-cart-steps__toggle').on('click', function() {
        const $steps = $(this).closest('.add-to-cart-steps');
        $(this).attr('aria-expanded', 'true');
        $steps.addClass('is-open');
        // The toggle is hidden once open, so move focus into the revealed form
        $steps.find('.add-to-cart-steps__form').trigger('focus');
    });
});